import React from "react"
import PropTypes from "prop-types"

export const CropIcon = ({ 
  height = 20, 
  width = 20, 
  fill = "var(--color-text-secondary-dark)", 
  stroke = "var(--color-text-secondary-dark)",
  strokeWidth = 1.5,
  ...props 
}) => (
  <svg 
    width={width} 
    height={height} 
    viewBox="0 0 16 16" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_25465_3327)">
      <path 
        d="M4.08667 0.666748L4 10.6667C4 11.0204 4.14048 11.3595 4.39052 11.6096C4.64057 11.8596 4.97971 12.0001 5.33333 12.0001H15.3333" 
        stroke={stroke} 
        strokeWidth={strokeWidth} 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M0.666504 4.08667L10.6665 4C11.0201 4 11.3593 4.14048 11.6093 4.39052C11.8594 4.64057 11.9998 4.97971 11.9998 5.33333V15.3333" 
        stroke={stroke} 
        strokeWidth={strokeWidth} 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_25465_3327">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
)

CropIcon.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fill: PropTypes.string,
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

CropIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: "#525455",
  stroke: "#525455",
  strokeWidth: 1.5
}

export default CropIcon